<template lang="pug">
  FormBlock.b-stage-tile(v-if="stage && project" mobile)
    TaskSortChangePopup(:tasks="activeTasks" ref="taskSortChangePopup")
    ._header
      StageForm._form(v-if="stage === editingStage" :stage="stage")
      template(v-else)
        //BaseCheckbox._master-checkbox(
        //  :value="selected.length === activeTasks.length && activeTasks.length > 0"
        //  @change="$refs.selectableList.selectAll($event)"
        //)
        ._title {{ stage.name }}
          Icon._edit(name="edit2" v-if="access.canEditStages()" pointer @click.native="editStage")
          NotificationCount(:count="notificationCount")
        BtnResort(:disabled="!activeTasks.length" @click="changeTaskSort")
        BtnUpDown._up-down(v-if="stage.id" @up="modelStage.swap(stage, -1)" @down="modelStage.swap(stage, + 1)")
        BtnExpand(:expanded="expanded" @toggle="toggleFolding")
        EllipsisMenu(v-if="stage.id" :items="menuItems")
    template(v-if="stage.id && expanded")
      SelectableList(
        :items="activeTasks"
        v-slot="{ items, checked, toggle, enter, leave, down }"
        ref="selectableList"
        @change="onTasksSelect"
      )
        DraggableList._tasks(
          :itemsRaw="items"
          :canReceive="access.isProjectAdmin() || access.isProjectAuthor()"
          type="task"
          v-slot="{ items, onDragStart, onDragEnter, onDragEnd, onDrop, draggableItem }"
          @change="resortTasks"
        )
          template(v-if="items.length")
            TaskTile._task(
              v-for="(task, i) in items"
              :key="task.id"
              :task="task"
              :project="project"
              :class="{ drag: draggableItem === task }"
              draggable
              @update="$emit('updateTask', $event)"
              @dragstart.native="onDragStart($event, task)"
              @dragenter.native="onDragEnter($event, task)"
              @dragover.native.prevent
              @dragend.native="onDragEnd(task)"
              @drop.native="onDrop(task)"
              @mouseenter.native="enter(i)"
            )
              template(v-slot:checkbox)
                BaseCheckbox(
                  white
                  :value="checked.has(i)"
                  @toggle="toggle(i, $event)"
                  @mouseleave.native="leave(i)"
                  @mousedown.native="down(i)"
                  @dragstart.native.prevent.stop
                  draggable
                )
          EmptyList(v-else label="Нет активных задач" @dragenter.native="onDragEnter($event, null)")
      ._show-closed-tasks(v-if="closedTasks.length")
        Btn(@click="toggleClosedTasks" grey transparent sm) {{ showClosedTasks ? 'Скрыть' : 'Показать' }} закрытые задачи
      SelectableList._tasks(
        v-if="showClosedTasks"
        :items="closedTasks"
        v-slot="{ items, checked, toggle, enter, leave, down }"
        ref="selectableListClosed"
        @change="onClosedTasksSelect"
      )
        TaskTile._task(
          v-for="(task, i) in items"
          :key="task.id"
          :task="task"
          :project="project"
          @update="$emit('updateTask', $event)"
          @mouseenter.native="enter(i)"
        )
          template(v-slot:checkbox)
            BaseCheckbox(
              white
              :value="checked.has(i)"
              @toggle="toggle(i, $event)"
              @mouseleave.native="leave(i)"
              @mousedown.native="down(i)"
              @dragstart.native.prevent.stop
              draggable
            )
      TaskAddForm(v-if="isTaskAdd" :stage="stage" @hide="isTaskAdd = false")
      ._footer(v-if="this.tasks.length || access.canCreateTask()")
        ._progress
          BaseProgressbar(v-bind="taskProgress" v-if="this.tasks.length")
        Btn(v-if="access.canCreateTask()" @click="isTaskAdd = true" dark xl)
          Icon(name="plus")
          | Новая задача

</template>

<script>
import modelStage from '@/model/stage';
import modelTaskList from '@/model/taskList';
import modelCustomSettings from '@/model/userCustomSettings';
import modelPopup from '@/model/popup';
import taskProgress from '@/utils/taskProgress';
import Access from '@/utils/access';

import FormBlock from '@/components/FormBlock.vue';
import TaskTile from '@/components/task/TaskTile.vue';
import NotificationCount from '@/components/base/NotificationCount.vue';
import BaseProgressbar from '@/components/BaseProgressbar.vue';
import EllipsisMenu from '@/components/EllipsisMenu.vue';
import StageForm from '@/components/StageForm.vue';
import BtnUpDown from '@/components/ui/BtnUpDown.vue';
import EmptyList from '@/components/ui/EmptyList.vue';
import BtnExpand from '@/components/ui/BtnExpand.vue';
import DraggableList from '@/components/draggable/DraggableList.vue';
import TaskAddForm from '@/components/task/detail/TaskAddForm.vue';
import TaskSortChangePopup from '@/components/task/TaskSortChangePopup.vue';
import BtnResort from '@/components/ui/BtnResort.vue';
import TaskCopyPopup from '@/components/task/TaskCopyPopup.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import SelectableList from '@/components/ui/SelectableList.vue';

export default {
  name: 'StageTile',
  components: {
    NotificationCount,
    SelectableList,
    BaseCheckbox,
    TaskSortChangePopup,
    TaskAddForm,
    BtnUpDown,
    StageForm,
    EllipsisMenu,
    FormBlock,
    BaseProgressbar,
    TaskTile,
    EmptyList,
    BtnExpand,
    DraggableList,
    BtnResort,
  },
  props: {
    stage: Object,
    tasks: Array,
    project: Object,
  },
  data() {
    return {
      isTaskAdd: false,
      isExpanded: false, // for work access only
      selected: [],
      selectedClosed: [],
    };
  },
  computed: {
    currUser() { return this.$store.state.auth.user; },
    access() { return new Access(this.project, this.currUser); },
    activeTasks() { return this.tasks.filter((t) => !t.isClosed); },
    closedTasks() { return this.tasks.filter((t) => t.isClosed); },
    taskProgress() { return taskProgress(this.tasks.length, this.closedTasks.length); },
    modelStage() { return modelStage; },
    editingStage() { return this.$store.state.stage.editingItem; },
    foldedStages() { return this.currUser.customSettings.foldedStages ?? []; },
    expanded() {
      if (!this.access.isProjectStandardMember() || this.activeTasks.length || this.closedTasks.length) {
        return !this.foldedStages.includes(this.stage.id);
      }

      return this.isExpanded;
    },
    expandedClosedTasks() { return this.currUser.customSettings.expandedClosedTasks ?? []; },
    showClosedTasks() { return this.expandedClosedTasks.includes(this.stage.id); },
    notificationCount() {
      const getter = this.$store.getters['notification/itemIdsByFilter'];
      return getter({ stageId: this.stage.id }).length;
    },
    menuItems() {
      const items = [];

      if (this.access.canEditStages()) {
        items.push({ text: 'Переименовать', icon: 'edit', handler: this.editStage });
        items.push({ text: 'Удалить', icon: 'trash', handler: this.deleteStage });
        items.push({ text: 'Копировать', icon: 'edit', handler: this.copyStage });
      }

      if (this.access.canCreateTask()) {
        items.push({ text: 'Добавить задачу', icon: 'add', route: { name: 'task-create', params: { stageId: this.stage.id } } });
      }

      items.push({ text: 'Сортировать задачи', icon: 'sort', handler: this.changeTaskSort });

      return items;
    },
  },
  methods: {

    editStage() { modelStage.edit(this.stage); },
    deleteStage() { modelStage.deleteFromList(this.stage); },
    copyStage() {
      modelPopup.add({
        args: ['stage', this.stage.id, { name: this.stage.name, tasks: this.tasks }],
        component: TaskCopyPopup,
      });
    },
    toggleFolding() {
      if (this.access.isProjectStandardMember()) {
        this.isExpanded = !this.expanded;
      }

      const foldedStages = this.expanded
        ? [...this.foldedStages, this.stage.id]
        : this.foldedStages.filter(i => i !== this.stage.id);
      modelCustomSettings.set({ foldedStages });
    },
    async changeTaskSort() {
      const res = await this.$refs.taskSortChangePopup.open();

      if (!res) return;

      this.resortTasks(res);
    },
    toggleClosedTasks() {
      const expandedClosedTasks = this.showClosedTasks
        ? this.expandedClosedTasks.filter(i => i !== this.stage.id)
        : [...this.expandedClosedTasks, this.stage.id];

      modelCustomSettings.set({ expandedClosedTasks });
    },
    resortTasks(tasks) { modelTaskList.resort(tasks, this.stage.id, this.project.id); },
    onTasksSelect(ids) {
      this.selected = ids;
      this.emitSelectedTasks();
    },
    onClosedTasksSelect(ids) {
      this.selectedClosed = ids;
      this.emitSelectedTasks();
    },
    emitSelectedTasks() {
      const tasks = [
        ...this.selected.map(i => this.activeTasks[i]),
        ...this.selectedClosed.map(i => this.closedTasks[i]),
      ];

      this.$emit('tasksSelected', tasks);
    },
    resetCheck() {
      this.$refs.selectableList?.reset();
      this.$refs.selectableListClosed?.reset();
    },
  },

};
</script>

<style scoped lang="scss">
.stage-tile {
  display: flex;
  flex-direction: column;
  gap: 35px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
  }

  &__title {
    font-size: 18px;
    line-height: 24px;
    position: relative;
    margin-right: auto;
    display: flex;
    align-items: center;
    gap: 15px;
  }

  &__edit {
    width: 15px;
    opacity: .5;
    transition: opacity .1s linear;
    flex-shrink: 0;

    &:hover {
      opacity: 1;
    }
  }

  &__subtitle {
    position: absolute;
    top: 100%;
    font-weight: bold;
    font-size: 11px;
    line-height: 24px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--color-middle-gray);
  }

  &__tasks {
    display: flex;
    flex-direction: column;
    gap: 1px;
  }

  &__footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__progress {
    width: 360px;
  }

  &__show-closed-tasks {
    display: flex;
    gap: 10px;
    align-items: center;

    ::v-deep .button.transparent {
      border-color: #D1D9F0 !important;
    }
    svg {
      fill: #8B8CA9;
    }

    &:before, &:after {
      display: block;
      content: '';
      height: 1px;
      background: #D1D9F0;
      flex-grow: 1;
    }
  }

  @media (max-width: 992px) {
    &__footer {
      gap: 30px;
    }

    &__progress {
      flex-basis: 0;
      flex-grow: 1;
    }

    &__footer {
      flex-direction: column;
      align-items: end;
    }

    &__progress {
      width: 100%;
    }
  }

  @media (max-width: 576px) {
    &__header {
      flex-wrap: wrap;
    }

    &__title {
      width: 100%;
    }

    &__up-down {
      margin-right: auto;
    }
  }
}
</style>
